import React from 'react';
import './index.css';
import {Button} from 'reactstrap';

function App() {
  return (
    <div className="App ">
       <div className="container-fluid ">
        <div className="row ">
          <div className="col-sm-3 col-md-3 col-lg-4 col-xl-3 " style={{background:"#7bc17e"}}>
               <div className="container" style={{height:"100vh",marginTop:"20px"}}>
                    
                      <div className="d-flex justify-content-center align-items-center" style={{color:"white",fontSize:"20px",fontStyle:"bold"}}>
                              Aditya Prakash
                      </div>
                     
                 <div className="row align-items-center">
                    
                      <img src="aditya-sq.jpg"  className="avatar" alt="aditya"/>
                     
                 
                 </div>

                 <div className="d-flex justify-content-center align-items-center" style={{color:"white",fontSize:"15px",fontStyle:"italic"}}>
                              Hi, I am Aditya Prakash. I am a Full Stack Developer . Welcome to my personal website.
                      </div>
                      <div className="row  m-top-20 " style={{justifyContent:"center",display: "flex"}}>
                    
                       <a  href="https://github.com/Aditya185" rel="noopener noreferrer" target="_blank"> <i className="fa fa-github fa-lg icon  " ></i> </a> 
                       <a className="m-left-20" href="https://www.linkedin.com/in/aditya-prakash-349a28162/" rel="noopener noreferrer" target="_blank"> <i className="fa fa-linkedin fa-lg icon "></i></a>
                       <a  className="m-left-20" href="https://www.facebook.com/aditya.prakash.75839" rel="noopener noreferrer" target="_blank">  <i className="fa fa-facebook fa-lg icon "></i></a>
                       <a  className="m-left-20" href="https://twitter.com/Adityaprakash02" rel="noopener noreferrer" target="_blank">  <i className="fa fa-twitter fa-lg icon "></i></a>
               
                      </div>
                      <hr className="white"></hr>
                      <div className="row justify-content-center" style={{color:"white",fontSize:"15px",fontStyle:"bold"}}> 
                          <div className="col-11 mx-auto">
                          <h4>Projects</h4>
                            <p className="m-top-20 ex1"><a id="special"  href="#android" >Android Projects</a></p>
                            
                            <p><a id="special" href="#react" >React Projects</a></p>
                            <p><a id="special" href="#html" >HTML,CSS and Bootstrap Projects</a></p>
                            <p><a id="special" href="#node" >Node,Mongodb and Express  Projects</a></p>
                            <p><a id="special" href="#internship" >Projects during an Internship</a></p>
                          </div>
                    

                      </div>

                      <hr className="white m-top-70 m-bottom-10"></hr>
                      <div className="row justify-content-center" style={{color:"white",fontSize:"15px"}}> 
                          <div className="col-11 mx-auto">
                            <h4>Contacts</h4>
                            <i className="fa fa-envelope fa-lg icon  " ><span className="m-left-10">adityaprakash185@gmail.com</span></i> 
                            <i className="fa fa-phone fa-lg icon m-top-20 " ><span className="m-left-10">+917563869613</span></i>
                            
                          </div>
                    

                      </div>
                 
             
                 </div>

          
          </div>
          <div className="col-sm-9 col-md-9 col-lg-8 col-xl-9">
               <div className="container-fluid" >

                 <div className="row justify-content-between">

                 <div className="col-7">
                    <h2 className="auto m-top-40">Aditya Prakash</h2>
                      <div>
                        <p className="mr-auto">Full Stack Developer</p>
                      </div>
                      <div>
                        <p className="mr-auto text-small">I am Full Stack Developer and currently doing B.tech(4th year) in CSE from IIIT Vadodara.
                                              I have experince of about 3 years in Android development with Java/Kotlin and Web development
                                              (React/Node/HTML/CSS/JS). I can also work in React-Native hybrid mobile app development.
   
                        </p>
                      </div>
                      <div>
                        <a href="https://drive.google.com/file/d/1-CoUycLna7l7CuwPzkvrAaWsBH1AQI49/view" rel="noopener noreferrer" target="_blank"><Button color="primary">View Resume</Button>{' '}</a>
                        
                       
                      </div>
                  </div>
                  <div className="col-4">
                    <img  className="m-top-20 " src="aditya-cover.jpg" alt="aditya-cover" width="300dp" height="200dp"></img>
                  </div>

                 </div>

               </div>
               <hr></hr>
               <div className="container-fluid">
                 <div className="row">
                     <h2>My Works</h2>

                 </div>
                 <div id="android" className="row justify-content-start">
                   <div className="col-12">
                       <img src="android.png" alt="android-icon"></img>
                       <span><strong>Android Projects</strong></span>
                       <hr></hr>
                       <div className="row justify-content-start">
                           <ul>
                             <li><strong>Flatter</strong></li>
                             <p>
                               An Android based messaging application taking the reference of whatsapp and facebook
                               In this app you can send request to other users after the request is accepted you become chat
                               friends and can talk with each other. The backend and database is based on firebase. This App
                               is developed using <strong>Java</strong>,<strong>XML</strong>  and <strong>NodeJs</strong> for notifications.<br></br>
                               <strong>Github Repo- </strong><a href="https://github.com/Aditya185/Flatter" rel="noopener noreferrer" target="_blank"> repo-link</a>
                               <br></br>
                               <strong>App Link- </strong><a href="https://drive.google.com/open?id=1K-sEMg7tzCavRt5efp124PjGKUc8kWpA" rel="noopener noreferrer" target="_blank"> app-link</a>
                               </p>
                               <br></br>
                               <strong>some screen-shots-</strong>
                               <div className="row justify-content-around m-top-20">
                                
                                 <div className="col col-sm-5 col-md-4 col-lg-4">
                                    <img src="flatter-1.png" alt="flatter-1" width="200px" height="300px"></img>
                                 </div>
                                 <div className="col col-sm-5 col-md-4 col-lg-4">
                                   <img src="flatter-2.png" alt="flatter-2" width="200px" height="300px"></img>
                                  </div>
                                  <div className="col col-sm-5 col-md-4 col-lg-4">
                                   <img src="flatter-3.png" alt="flatter-3" width="200px" height="300px"></img>
                                  </div>

                               </div>
                             
                             <li><strong>Shop Organizer</strong></li>
                              <p>
                                An Android based application developed for shopkeepers to organize their shops in an efficent way.
                                They can keep day to day sell data, customer data, items locations, this app has functionalities of
                                bar-code scanner and invoice generator and invoice can be sent directly via SMS to customer phone no through this
                                app.The backend and database is based on firebase. This App
                                is developed using <strong>Java </strong>and<strong> XML</strong>.<br></br>
                                <strong>Github Repo- </strong><a href="https://github.com/Aditya185/ShopMaking" rel="noopener noreferrer" target="_blank"> repo-link</a>
                                <br></br>
                                <strong>App Link- </strong><a href="https://drive.google.com/file/d/1cY_z9hZyrZ3uatv9LnxCgvqlUmySpJNv/view?usp=sharing" rel="noopener noreferrer" target="_blank"> app-link</a>
                              </p>
                              <strong>some screen-shots-</strong>
                               <div className="row justify-content-around m-top-20">
                                
                                 <div className="col col-sm-5 col-md-4 col-lg-4">
                                    <img src="shop-1.jpeg" alt="shop-1" width="200px" height="300px"></img>
                                 </div>
                                 <div className="col col-sm-5 col-md-4 col-lg-4">
                                   <img src="shop-2.jpeg" alt="shop-2" width="200px" height="300px"></img>
                                  </div>
                                  <div className="col col-sm-5 col-md-4 col-lg-4">
                                   <img src="shop-3.jpeg" alt="shop-3" width="200px" height="300px"></img>
                                  </div>

                               </div>
                              <li><strong>Recognizer</strong></li>
                                <p>
                                  An Android based application using Firebase ML-kit to recognize text and labels from the images. 
                                   This App
                                  is developed using <strong>Java </strong>and<strong> XML</strong>.<br></br>
                                  <strong>Github Repo- </strong><a href="https://github.com/Aditya185/Recognizer" rel="noopener noreferrer" target="_blank"> repo-link</a>
                                  <br></br>
                                  <strong>App Link- </strong><a href="https://drive.google.com/open?id=1pKCl1B3vpRnNvVd94DQUnm2FXZy2feaG" rel="noopener noreferrer" target="_blank"> app-link</a>
                                </p>
                                <br></br>
                               <strong>some screen-shots-</strong>
                               <div className="row justify-content-around m-top-20">
                                
                                 <div className="col col-sm-5 col-md-4 col-lg-4">
                                    <img src="reco-1.png" alt="reco-1" width="200px" height="300px"></img>
                                 </div>
                                 <div className="col col-sm-5 col-md-4 col-lg-4">
                                   <img src="reco-2.png" alt="reco-2" width="200px" height="300px"></img>
                                  </div>
                                  <div className="col col-sm-5 col-md-4 col-lg-4">
                                   <img src="reco-3.png" alt="reco-3" width="200px" height="300px"></img>
                                  </div>

                               </div>
                                <li><strong>Ap Messenger</strong></li>
                                <p>
                                  An Android based messaging application taking reference of facebook-messenger based on Firebase. 
                                   This App
                                  is developed using <strong>Kotlin </strong>and<strong> XML</strong>.<br></br>
                                    
                                  <strong>App Link- </strong><a href="https://drive.google.com/open?id=1tJgPA1NEZN7a5wjUVcvsDJmKsR_Ar6ur" rel="noopener noreferrer" target="_blank"> app-link</a>
                                </p>
                           </ul>
                       </div>

                   </div>
                  

                 </div>
                 <div id="react" className="row justify-content-start">
                   <div className="col-12">
                       <img src="react.png" alt="react-icon"></img>
                       <span><strong>React Projects</strong></span>
                       <hr></hr>
                       <div className="row justify-content-start">
                           <ul>
                             <li><strong>Would You Rather</strong></li>
                             <p>
                             In the "Would You Rather?" Project, I have build a web app that lets a user play the “Would You Rather?” game. The game goes like this: A user is asked a question in the form: “Would you rather [option A] or [option B] ?”. Answering "neither" or "both" is against the rules.
                              In this app, users will be able to answer questions, see which questions they haven’t answered, see how other people have voted, post questions, and see the ranking of users on the leaderboard. This App
                               is developed using <strong>ReactJs</strong>,<strong>Bootstrap</strong>  and it uses <strong>Redux</strong> for store management.<br></br>
                               <strong>Github Repo- </strong><a href="https://github.com/Aditya185/would-you-rather" rel="noopener noreferrer" target="_blank"> repo-link</a>
                               <br></br>
                               <strong>App Link- </strong><a href="https://eloquent-saha-4c3149.netlify.app/" rel="noopener noreferrer" target="_blank"> app-link</a>
                             </p>
                             <li><strong>My Reads</strong></li>
                              <p>
                              In the MyReads project, I have created a bookshelf app that allows you to select and categorize books you have read, are currently reading, or want to read. This App
                                is developed using <strong>ReactJs  </strong>and<strong> Bootstrap</strong>.<br></br>
                                <strong>Github Repo- </strong><a href="https://github.com/Aditya185/React-Nanodegree-Project-1-MyReads" rel="noopener noreferrer" target="_blank"> repo-link</a>
                                <br></br>
                                <strong>App Link- </strong><a href="https://angry-carson-4096c9.netlify.app/" rel="noopener noreferrer" target="_blank"> app-link</a>
                              </p>
                              <li><strong>Mobile FlashCards</strong></li>
                                <p>
                                  An React Native based mobile application. It is basically a quiz game app which has different question cards for a quiz.
                                  You can play quiz on this app add your questions and create your own quizes and on quiz completion it shows the final result.                          This App
                                  This app is developed using <strong>React-Native </strong>.<br></br>
                                  <strong>Github Repo- </strong><a href="https://github.com/Aditya185/mobile-flash-cards" rel="noopener noreferrer" target="_blank"> repo-link</a>
                                  <br></br>
                                  
                                </p>
                                <br></br>
                               <strong>some screen-shots-</strong>
                               <div className="row justify-content-around m-top-20">
                                
                                 <div className="col col-sm-5 col-md-4 col-lg-4">
                                    <img src="flash-1.png" alt="flash-1" width="200px" height="300px"></img>
                                 </div>
                                 <div className="col col-sm-5 col-md-4 col-lg-4">
                                   <img src="flash-4.png" alt="flash-4" width="200px" height="300px"></img>
                                  </div>
                                  <div className="col col-sm-5 col-md-4 col-lg-4">
                                   <img src="flash-3.png" alt="flash-3" width="200px" height="300px"></img>
                                  </div>

                               </div>
                           </ul>
                       </div>

                   </div>
                  

                 </div>

                 <div id="html" className="row justify-content-start">
                   <div className="col-12">
                       <img src="html.png" alt="react-icon"></img>
                       <img src="css.png" alt="react-icon"></img>
                       <img src="bootstrap.png" alt="react-icon"></img>
                       <span><strong>HTML CSS and Bootstrap Projects</strong></span>
                       <hr></hr>
                       <div  className="row justify-content-start">
                           <ul>
                             <li><strong>Resturant Site</strong></li>
                             <p>
                               A Site for a resturant displaying its menus,address and all the details about the resturant.
                            .<br></br>
                               <strong>Github Repo- </strong><a href="https://github.com/Aditya185/Restaurant_Bootstrap_site" rel="noopener noreferrer" target="_blank"> repo-link</a>
                               <br></br>
                              
                             </p>
                             <br></br>
                               <strong>some screen-shots-</strong>
                               <div className="row justify-content-around m-top-20">
                                
                                 <div className="col-8">
                                    <img src="boot-1.png" alt="reco-1" width="400px" height="500px"></img>
                                 </div>
                                

                               </div>
                            
                           </ul>
                       </div>

                   </div>
                  

                 </div>
                 <div id="node"  className="row justify-content-start">
                   <div className="col-12">
                       <img src="node.png" alt="react-icon"></img>
                       <img src="mongo.png" alt="react-icon"></img>
                       <img src="express.png" width="100dp" alt="react-icon"></img>
                       <span><strong>Node Mongodb and Express Projects</strong></span>
                       <hr></hr>
                       <div id="html" className="row justify-content-start">
                           <ul>
                             <li><strong>API for an Android app</strong></li>
                             <p>
                               An API designed for an android application to maintain its users and authorized users and their corresonding data and 
                               save to mongodb database. This API authenticates the users,provide login signup request to application and provides all
                               the requests like GET,PUT,PATCH,DELETE,POST. some of its endpoints - /users , /users/{`userid`} , /signup ,/login e.t.c
                            .<br></br>
                               <strong>API - </strong><a href="https://lit-waters-85247.herokuapp.com/" rel="noopener noreferrer" target="_blank"> api</a>
                               <br></br>
                              
                             </p>
                            
                           </ul>
                       </div>

                   </div>
                  

                 </div>

                 <div id="internship" className="row justify-content-start">
                   <div className="col-12">
                       
                       <span><strong>Projects during 2 Internships</strong></span>
                       <hr></hr>
                       <div  className="row justify-content-start">
                           <ul>
                             <li><strong>Simba Application</strong></li>
                             <p>
                               I worked on this app with the android team of Logyana Solutions which is basically a platform for shops to provide discount and advertise their shops and brands.
                            <br></br>
                               <strong>Playstore Link- </strong><a href="https://play.google.com/store/apps/details?id=simba.apk" rel="noopener noreferrer" target="_blank"> link</a>
                               <br></br>
                              
                             </p>
                             <br></br>

                             <li><strong>App Bank</strong></li>
                             <p>
                               I worked on this app with the android team of Logyana Solutions which is all in one app contains many apps in a single application.
                            <br></br>
                               <strong>Playstore Link- </strong><a href="https://play.google.com/store/apps/details?id=com.appbank" rel="noopener noreferrer" target="_blank"> link</a>
                               <br></br>
                              
                             </p>
                             <br></br>
                              
                             <li><strong>Pods</strong></li>
                             <p>
                               I worked on this app with the android team of Zersey Infotech which is a art and design application with many features.
                            <br></br>
                               <strong>Playstore Link- </strong><a href="https://play.google.com/store/apps/details?id=com.podium.app&hl=en" rel="noopener noreferrer" target="_blank"> link</a>
                               <br></br>
                              
                             </p>
                             <br></br>
                               
                            
                           </ul>
                       </div>

                   </div>
                  

                 </div>


               </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
